var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRequestError)?_c('ol',{staticClass:"form__server-error"},_vm._l((_vm.getError),function(item,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(item.msgText)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }